module.exports = __webpack_public_path__ + "static/conchiglia-a3814515c85a6db7218e4256f84a7b5a.png";